/** @format */

import React from "react";
import FileUpload from "./FileUpload";
import Input from "./Input";
import Select from "./Select";

const FormControl = ({ control, ...rest }) => {
  switch (control) {
    case "input":
      return <Input {...rest} />;
    case "select":
      return <Select {...rest} />;
    case "file":
      return <FileUpload {...rest} />;
  }
};

export default FormControl;
